(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvDocumentTemplateEditorPdfFont', drvDocumentTemplateEditorPdfFont);

    drvDocumentTemplateEditorPdfFont.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvDocumentTemplateEditorPdfFont
     *
     * @description
     * Font selector for PDF editor
     *
     * # Scope Params
     * {Array} selectedPdfElements - An array of PDFedit.elements.PdfElement
     * {DocumentTemplate} documentTemplate
     */
    function drvDocumentTemplateEditorPdfFont() {
        var directive = {
            controller: DocumentTemplateEditorPdfFontCtrl,
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                selectedPdfElements: '<',
                documentTemplate: '<?'
            },
            restrict: 'E',
            template:
                '<select title="Font Name" ng-model="vm.selectedFontName" ng-options="font as font for font in vm.fontNames"></select>' +
                ' <input title="Font Size" type="number" ng-model="vm.selectedFontSize" style="width: 50px;"></input>' +
                ' <drv-tool-bar-button label="Bold" icon-usage="bold" is-checked="vm.selectedFontBold" ng-click="vm.selectedFontBold = !vm.selectedFontBold"></drv-tool-bar-button>' +
                '<drv-tool-bar-button label="Italic" icon-usage="italic" is-checked="vm.selectedFontItalic" ng-click="vm.selectedFontItalic = !vm.selectedFontItalic"></drv-tool-bar-button>'
        };
        
        DocumentTemplateEditorPdfFontCtrl.$inject = ['pdfedit_fontList'];

        return directive;

        function DocumentTemplateEditorPdfFontCtrl(pdfedit_fontList) {
            var vm = this;
            vm.fontNames = pdfedit_fontList;

            Object.defineProperty(vm, 'selectedFontName', {
                get: function () { return getCommonProperty('fontName'); },
                set: function (newFontName) { setCommonProperty('fontName', newFontName); }
            });

            Object.defineProperty(vm, 'selectedFontSize', {
                get: function () { return getCommonProperty('fontSize'); },
                set: function (newFontSize) {
                    if (isFinite(newFontSize)) {
                        setCommonProperty('fontSize', newFontSize);
                    }
                }
            });

            Object.defineProperty(vm, 'selectedFontBold', {
                get: function () { return getCommonProperty('fontBold'); },
                set: function (newFontBold) { setCommonProperty('fontBold', newFontBold ? true : false); }
            });

            Object.defineProperty(vm, 'selectedFontItalic', {
                get: function () { return getCommonProperty('fontItalic'); },
                set: function (newFontItalic) { setCommonProperty('fontItalic', newFontItalic ? true : false); }
            });

            /**
             * Gets the property value if it's the same value among all selected elements that
             * have that property defined. Returns null if no selected elements have that property
             * or if the value of that property among selected elements differs.
             */
            function getCommonProperty(propertyName) {
                var commonValue = null;

                if (vm.selectedPdfElements.length === 0 &&
                    angular.isDefined(vm.documentTemplate) &&
                    angular.isDefined(vm.documentTemplate.data.AdvancedSettings.DefaultFont) &&
                    vm.documentTemplate.data.AdvancedSettings.DefaultFont !== null) {

                    if (angular.isDefined(vm.documentTemplate.data.AdvancedSettings.DefaultFont[propertyName])) {
                        commonValue = vm.documentTemplate.data.AdvancedSettings.DefaultFont[propertyName];
                    }

                } else {
                    for (var i = 0; i < vm.selectedPdfElements.length; i++) {
                        if (angular.isDefined(vm.selectedPdfElements[i][propertyName])) {
                            if (commonValue === null) {
                                commonValue = vm.selectedPdfElements[i][propertyName];
                            } else if (commonValue !== vm.selectedPdfElements[i][propertyName]) {
                                return null;
                            }
                        }
                    }
                }

                return commonValue;
            }

            /**
             * Sets the property value on all selected elements that have that property defined.
             */
            function setCommonProperty(propertyName, propertyValue) {
                if (vm.selectedPdfElements.length === 0 && angular.isDefined(vm.documentTemplate)) {
                    if (angular.isUndefined(vm.documentTemplate.data.AdvancedSettings.DefaultFont) || vm.documentTemplate.data.AdvancedSettings.DefaultFont === null) {
                        vm.documentTemplate.data.AdvancedSettings.DefaultFont = {};
                    }
                    vm.documentTemplate.data.AdvancedSettings.DefaultFont[propertyName] = propertyValue;
                } else {
                    for (var i = 0; i < vm.selectedPdfElements.length; i++) {
                        if (angular.isDefined(vm.selectedPdfElements[i][propertyName])) {
                            vm.selectedPdfElements[i][propertyName] = propertyValue;
                        }
                    }
                }
            }
        }
    }
})();